__turbopack_context__.v({
  "container": "XAfcaW_container",
  "headlineContainer": "XAfcaW_headlineContainer",
  "mapView": "XAfcaW_mapView",
});
